const openWinUrl = [
    'https://www.dropbox.com/',
    'https://www.moments.realestate/',
    'https://vimeo.com/',
    'https://rmt.co/',
    'https://krgroup.ca/',
    'https://www.krgroup.ca/',
    'https://sites.intextphotography.com/',
    'https://listing.otbxair.com/'
];

function isOpenWin(url, globalData) {
    let no_iframe_virtual_url = [...openWinUrl];
    if (globalData.no_iframe_virtual_url) {
        try {
            no_iframe_virtual_url = no_iframe_virtual_url.concat(
                JSON.parse(globalData.no_iframe_virtual_url)
            );
        } catch (e) {
            console.error(e);
        }
    }
    return no_iframe_virtual_url.some(v => new RegExp(`^${v}`).test(url));
}

export default isOpenWin;
